export default class RIXItemComm {
    getProductData(id) {
        const headers = new Headers({
            'X-Client-id': window.Checkout.settings.API_adapter.itemComm.adapter.client_id,
        });

        const init = {
            method: 'GET',
            headers: headers,
        };

        return fetch(window.Checkout.settings.API_adapter.itemComm.adapter.endpoint + '/salesitem/communications/ru/' + window.Checkout.settings.country_code + '?itemNos=' + id, init);
    }
}
